<template>
	<div>
		
		
		
		<el-dialog :close-on-press-escape="false" :close-on-click-modal="false" top="5vh" title="基础信息修改" :visible.sync="changeClassTimelog" width="50%">
			<el-form label-position="right" ref="editInfoForm" label-width="100px">
				<el-form-item label="课程">
					{{ classDetail.courseName }}
				</el-form-item>
				<el-form-item label="课节">
					{{ classDetail.className }}
				</el-form-item>
				<el-form-item label="">
					请输入新的预定时间，时区以您当前时区为准。
				</el-form-item>
				<el-form-item label="预定开始">
					<el-date-picker style="width: 100%" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
						v-model="classDetail.startTime" type="datetime" placeholder="选择日期">
					</el-date-picker>
				</el-form-item>
				
				<el-form-item label="预定结束">
					<el-date-picker  style="width: 100%" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
						v-model="classDetail.endTime" type="datetime" placeholder="选择日期">
					</el-date-picker>
				</el-form-item>
		
			</el-form>
			<div style="height: 10px; margin-top: 20px; margin-bottom: 20px; text-align: center">
				<el-button @click="changeClassTimelog = false" round>取消</el-button>
				<el-button type="primary" @click="confirmTime2" round>确 定</el-button>
			</div>
		</el-dialog>
		
		<el-dialog :close-on-press-escape="false" :close-on-click-modal="false" top="5vh" title="基础信息修改" :visible.sync="classDetailDialog" width="50%">
			<el-form label-position="right" ref="editInfoForm" label-width="100px">
				<el-form-item label="课程">
					{{ classDetail.courseName }}
				</el-form-item>
				<el-form-item label="课节">
					{{ classDetail.className }}
				</el-form-item>
				<el-form-item label="时区">
					<el-switch style="margin-left:5px;" size="small" v-model="ifPek" active-text="(DFW)" inactive-text="(PEK)">
					</el-switch>
				</el-form-item>
				<el-form-item label="实际进入">
					<el-date-picker @change="changeClassTime" style="width: 100%" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
						v-model="classDetail.classFastln" type="datetime" placeholder="选择日期">
					</el-date-picker>
				</el-form-item>
				
				<el-form-item label="实际离开">
					<el-date-picker @change="changeClassTime" style="width: 100%" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
						v-model="classDetail.classLastout" type="datetime" placeholder="选择日期">
					</el-date-picker>
				</el-form-item>
				<el-form-item label="时薪类型">
					<el-radio-group style="width: 100%" v-model="classDetail.types">
						<el-radio label="USD">美元</el-radio>
						<el-radio label="CNY">人民币</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="时薪">
					<el-input-number v-model="classDetail.classRate" :precision="2">
					</el-input-number>
				</el-form-item>
				<el-form-item label="计费时长">
					<el-input-number  v-model="classDetail.billDuration" :precision="2">
					</el-input-number>
				</el-form-item>
				<el-form-item label="课节类型">
					<el-radio-group style="width: 100%" v-model="classDetail.isFree">
						<el-radio :label="false">正常课节</el-radio>
						<el-radio :label="true">赠送课节</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="课节性质">
					<el-radio-group style="width: 100%" v-model="classDetail.isPublic">
						<el-radio :label="false">非公开课</el-radio>
						<el-radio :label="true">公开课</el-radio>
					</el-radio-group>
					
				</el-form-item>
		
			</el-form>
			<div style="height: 10px; margin-top: 20px; margin-bottom: 20px; text-align: center">
				<el-button @click="classDetailDialog = false" round>取消</el-button>
				<el-button type="primary" @click="confirmTime" round>确 定</el-button>
			</div>
		</el-dialog>
		
		<el-dialog :close-on-press-escape="false" :close-on-click-modal="false" width="40%" title="评价详情" :visible.sync="classRateDialog">
		  <el-tabs v-model="rateIndex">
			<el-tab-pane label="学生评价" name="first">
			</el-tab-pane>
			<el-tab-pane label="无需评价" name="second"></el-tab-pane>
		  </el-tabs>

		  <el-form ref="form" v-if="rateIndex == 'first'?(rate.ifSuccess == 1 || rate.ifSuccess == 2):rate.ifSuccess == 3" label-position="top" style="padding:10px 0px 10px 0px;" v-for="(rate,index) in classRateDetail">
			<el-form-item label="">
				<el-tag style="width:70%;" effect="plain">
				{{getContractTime(rate.appointedTime)+" "+(rate.types == 1?'初始评价':rate.types == 2?'阶段评价':(classRateTypes == 1?'课节评价':'结束评价'))}}
				{{rate.ifSuccess == 1?'未评价':rate.ifSuccess == 2?(' （ '+getContractTime(rate.updateTime)+' 已评价 ）'):'无需评价'}}</el-tag>
			</el-form-item>
			<el-form-item v-if="rate.ifSuccess == 2" v-for="(item,index) in rate.details" :label="item.content">
			  <el-rate style="display: inline-block;zoom: 135%;vertical-align: top;margin-top:2.5px;" readonly :allow-half="true"  v-model="item.rate" disabled></el-rate>
			<i style="color:#F56C6C;margin-left:-3px;font-weight:bold;display: inline-block;font-size:25px;" class="el-icon-warning-outline" v-if="item.rate > 0 && item.rate < 3"></i>
			<i style="color:#ffe731;margin-left:-3px;font-weight:bold;display: inline-block;font-size:25px;" class="el-icon-warning-outline" v-if="item.rate >= 3 && item.rate < 4"></i>
			</el-form-item>
			<el-form-item v-if="rate.ifSuccess == 2" label="评价内容">
			  <el-input readonly=""
				type="textarea" style="width:50%"
				 :autosize="{ minRows: 0}"
				placeholder="" maxlength="100"
				v-model="rate.remark">
			  </el-input>
			</el-form-item>
		  </el-form>
		</el-dialog>
		
		<el-dialog :close-on-press-escape="false" :close-on-click-modal="false" top="5vh" title="创建课节" :visible.sync="addClassMode">
			<el-form label-width="120px">
				<el-form-item label="课程">
					<span style="font-weight:bold;">{{editCourseDetail.courseName}}</span>
				</el-form-item>
				<el-form-item label="课节名称">
					 <el-select @change="$forceUpdate()" style="width:100%;" v-model="editClassDetail.classNameIndex" placeholder="请选择">
					    <el-option
					      v-for="item in classType"
					      :key="item.id"
					      :label="item.content"
					      :value="item.id">
					    </el-option>
					  </el-select>
					  <el-input maxlength="60" v-if="editClassDetail.classNameIndex == 1" v-model="editClassDetail.className" placeholder="请输入课节名称"></el-input>
				</el-form-item>
				<el-form-item label="课节类型">
					<el-radio @change="$forceUpdate()" v-model="editClassDetail.classType" :label="0">正常课节</el-radio>
					  <el-radio @change="$forceUpdate()" v-model="editClassDetail.classType" :label="1">赠送课节</el-radio>
				</el-form-item>
				
				<el-form-item label="您的时区">
					  <el-input  readonly maxlength="150"  v-model="editClassDetail.timezone"></el-input>
				</el-form-item>
				<el-form-item label="上课时间">
					<el-date-picker @change="handle"  :picker-options="pickerOptions" v-model="editClassDetail.startTime" type="datetime"
						value-format="yyyy-MM-dd HH:mm" format="yyyy-MM-dd HH:mm" placeholder="选择上课时间">
					</el-date-picker>
				
				</el-form-item>
				<el-form-item label="上课时长(分钟)">
					<el-input-number @change="$forceUpdate()" :step="15" v-model="editClassDetail.number" :min="15" :max="120" label="上课时间(分钟)"></el-input-number>
				</el-form-item>
				<el-form-item label="云端录课">
					 <el-checkbox  @change="changeRecord"  :true-label="1" :false-label="0"  v-model="editClassDetail.record">录制教室</el-checkbox>
					 <el-checkbox @change="changeRecord"   :true-label="1" :false-label="0"  v-model="editClassDetail.recordScene">录制现场</el-checkbox>
				</el-form-item>
				<el-form-item label="直播/回放">
					 <el-checkbox @change="changeRecord"  :true-label="1" :false-label="0"  v-model="editClassDetail.live">网页直播</el-checkbox>
					 <el-checkbox  @change="changeRecord"  :true-label="1" :false-label="0"  v-model="editClassDetail.replay">网页回放</el-checkbox>
				</el-form-item>
				<el-form-item label="">
					 <el-checkbox  :true-label="1" :false-label="0"  v-model="editClassDetail.watchByLogin">必须登录账号才可以查看回放</el-checkbox>
				</el-form-item>
				<el-form-item label="选择导师">
					<el-select @change="changeSelect"  size="small" v-model="editClassDetail.teacherId" filterable placeholder="选择导师">
					    <el-option
					      v-for="item in teacherList"
					      :key="item.id"
					      :label="item.teacherName"
					      :value="item.id">
					    </el-option>
					  </el-select>
				</el-form-item>
				<el-form-item label="时薪类型" >
					<el-radio-group disabled v-model="editClassDetail.types">
						<el-radio label="USD">美元</el-radio>
						<el-radio label="CNY">人民币</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="时薪">
					<el-input-number disabled v-model="editClassDetail.classRate"  :precision="2">
					</el-input-number>
				</el-form-item>
			</el-form>
			<div style="text-align: center;">
				<el-button @click="checkAddClass" :disabled="!ifSubmit" size="small"
					type="primary" icon="el-icon-plus" round> 确认创建 </el-button>
			</div>
		</el-dialog>
		
		<el-dialog :close-on-press-escape="false" :close-on-click-modal="false" top="5vh" title="修改课程" :visible.sync="updCourseMode">
			<el-form label-width="100px">
				<el-form-item label="课程名称">
					<el-input maxlength="40" v-model="editCourseDetail.courseName" placeholder="请输入课程名称"></el-input>
				</el-form-item>
				<!-- <el-form-item label="选择学生">
					<el-select  size="small" v-model="editCourseDetail.studentId" filterable placeholder="选择学生">
					    <el-option
					      v-for="item in studentList"
					      :key="item.id"
					      :label="item.studentName"
					      :value="item.id">
					    </el-option>
					  </el-select>
				</el-form-item> -->
				<el-form-item label="学生邮箱">
					<el-input maxlength="100" v-model="editCourseDetail.email" placeholder="请输入学生邮箱"></el-input>
				</el-form-item>
				<el-form-item label="选择班主任">
					<el-select  size="small" v-model="editCourseDetail.headmasterId" filterable placeholder="选择班主任">
					    <el-option
					      v-for="item in headmasterList"
					      :key="item.id"
					      :label="item.headmasterName"
					      :value="item.id">
					    </el-option>
					  </el-select>
				</el-form-item>
			</el-form>
			<div style="text-align: center;">
				<el-button @click="checkUpdCourse" :disabled="!ifSubmit" size="small"
					type="primary" icon="el-icon-edit" round> 确认修改 </el-button>
			</div>
		</el-dialog>
		
		<el-dialog :close-on-press-escape="false" :close-on-click-modal="false" top="5vh" title="新增课程" :visible.sync="addCourseMode">
			<el-form label-width="100px">
				<el-form-item label="课程名称">
					<el-input maxlength="40" v-model="editCourseDetail.courseName" placeholder="请输入课程名称"></el-input>
				</el-form-item>
				<el-form-item label="总课时(分)">
					  <el-radio v-model="editCourseDetail.durationType" :label="1">
						  <el-input oninput="if(value.length > 9) value=value.slice(0, 9)" style="width:200px;display:inline-block;"
						  type="number" v-model="editCourseDetail.totalDuration" placeholder="请输入课时"></el-input>
						  （{{convertHours(editCourseDetail.totalDuration)}}）
					  </el-radio><br>
					  <el-radio v-model="editCourseDetail.durationType" :label="2">+ ∞</el-radio>
				</el-form-item>
				<el-form-item label="选择学生">
					<el-select  size="small" v-model="editCourseDetail.studentId" filterable placeholder="选择学生">
					    <el-option
					      v-for="item in studentList"
					      :key="item.id"
					      :label="item.studentName"
					      :value="item.id">
					    </el-option>
					  </el-select>
				</el-form-item>
				<el-form-item label="学生邮箱">
					<el-input maxlength="100" v-model="editCourseDetail.email" placeholder="请输入学生邮箱"></el-input>
				</el-form-item>
				<el-form-item label="选择班主任">
					<el-select  size="small" v-model="editCourseDetail.headmasterId" filterable placeholder="选择班主任">
					    <el-option
					      v-for="item in headmasterList"
					      :key="item.id"
					      :label="item.headmasterName"
					      :value="item.id">
					    </el-option>
					  </el-select>
				</el-form-item>
				<el-form-item label="合同开始时间">
					<el-date-picker v-model="editCourseDetail.startTime" value-format="yyyy-MM-dd" type="date"
						format="yyyy-MM-dd" placeholder="选择合同开始时间">
					</el-date-picker>
				</el-form-item>
				<el-form-item label="合同结束时间">
					<el-date-picker v-model="editCourseDetail.endTime" value-format="yyyy-MM-dd" type="date"
						format="yyyy-MM-dd" placeholder="选择合同结束时间">
					</el-date-picker>
				</el-form-item>
			</el-form>
			<div style="text-align: center;">
				<el-button @click="checkAddCourse" :disabled="!ifSubmit" size="small"
					type="primary" icon="el-icon-plus" round> 确认新增 </el-button>
			</div>
		</el-dialog>	
		
		<el-dialog :close-on-press-escape="false" :close-on-click-modal="false" width="50%" title="填写约课信息" :visible.sync="appointmentsDialog">
			<el-form label-width="100px">
				<el-form-item label="课程">
					  <el-input  readonly maxlength="150"  v-model="appointmentsDetail.courseName"></el-input>
				</el-form-item>
				<el-form-item label="您的时区">
					  <el-input  readonly maxlength="150"  v-model="appointmentsDetail.timezone"></el-input>
				</el-form-item>
				
				<el-form-item label="上课倾向时间">
					<el-button  size="small"
						type="primary" @click="addStudentTime()" icon="el-icon-plust" round> 点击选择上课倾向时间 </el-button>
						<el-tag style="margin-left: 10px;">请注意上述选择时间范围为班主任所在时区</el-tag>
					<div style="height:18px;font-size:12.5px;" v-for="(item,index) in studentShowTime">
						{{item}}
					</div>
				</el-form-item>
				<el-form-item label="课节名称">
					 <el-select @change="$forceUpdate()" style="width:100%;" v-model="appointmentsDetail.classNameIndex" placeholder="请选择">
					    <el-option
					      v-for="item in classType"
					      :key="item.id"
					      :label="item.content"
					      :value="item.id">
					    </el-option>
					  </el-select>
					  <el-input maxlength="60" v-if="appointmentsDetail.classNameIndex == 1" v-model="appointmentsDetail.className" placeholder="请输入课节名称"></el-input>
				</el-form-item>
				 <el-form-item label="课节类型">
					<el-radio @change="$forceUpdate()"   v-model="appointmentsDetail.classType" :label="0">正常课节</el-radio>
					  <el-radio @change="$forceUpdate()"  v-model="appointmentsDetail.classType" :label="1">赠送课节</el-radio>
				 </el-form-item>
				<!-- <el-form-item label="课节标签">
				 	<el-input maxlength="45" @input="$forceUpdate()" v-model="appointmentsDetail.classLabel" ></el-input>
				 </el-form-item> -->
				<el-form-item v-if="item.name != '倾向导师'" v-for="(item,index) in appointmentsDetail.demandInformation" :label="item.name">
					<el-input :autosize="{ minRows: 2}" type="textarea" maxlength="500" v-model="item.content"></el-input>
				</el-form-item>
				
				<el-form-item label="需求附件">
					<div v-for="(item,index) in appointmentsDetail.file">
						<el-input :value="item.name" style="display: inline-block;width:86%;"></el-input>
						<div style="display: inline-block;width:14%;text-align: right;">
							<el-button circle icon="el-icon-remove-outline" size="small" @click="delFile(index)"></el-button>
						</div>
					</div>
					<el-button type="primary" icon="el-icon-plus" size="small" @click="choiceImg()" circle></el-button>
					<input hidden="true" id="topFile" type="file" class="upload-file" @change="getFile()">
					<br>
					<el-tag>如有需要，请提供需求描述相关的附件，如简历、数据等</el-tag>
				</el-form-item>
				
				<el-form-item label="预计课节时长">
					<el-input-number  @change="$forceUpdate()" :step="15"  :min="15" :max="120" label="上课时间(分钟)" v-model="appointmentsDetail.classHours" style="width: 217px" :precision="2">
					</el-input-number>
					<span style="display: inline-block;margin-left:10px;">分钟</span>
				</el-form-item>
				
				<el-form-item label="云端录课">
					 <el-checkbox  @change="changeRecord2"  :true-label="1" :false-label="0"  v-model="appointmentsDetail.record">录制教室</el-checkbox>
					 <el-checkbox @change="changeRecord2"   :true-label="1" :false-label="0"  v-model="appointmentsDetail.recordScene">录制现场</el-checkbox>
				</el-form-item>
				
				<el-form-item label="直播/回放">
					 <el-checkbox @change="changeRecord2"  :true-label="1" :false-label="0"  v-model="appointmentsDetail.live">网页直播</el-checkbox>
					 <el-checkbox  @change="changeRecord2"  :true-label="1" :false-label="0"  v-model="appointmentsDetail.replay">网页回放</el-checkbox>
				</el-form-item>
				
				<el-form-item label="">
					 <el-checkbox @change="$forceUpdate()" :true-label="1" :false-label="0"  v-model="appointmentsDetail.watchByLogin">必须登录账号才可以查看回放</el-checkbox>
				</el-form-item>
				
				<el-form-item label="分配模式">
					 <el-radio @change="$forceUpdate()" v-model="appointmentsDetail.classModel"  :label="1">抢单模式</el-radio>
					 <el-radio @change="$forceUpdate()" v-model="appointmentsDetail.classModel"  :label="2">顺延模式</el-radio>
				</el-form-item>
				<el-form-item v-if="appointmentsDetail.classModel == 1" label="超时时间">
					 <el-input-number @change="$forceUpdate()" :min="1" :max="120" label="" v-model="appointmentsDetail.classModelHours" style="width: 217px" :precision="2">
					 </el-input-number>
					 <span style="display: inline-block;margin-left:10px;">小时</span>
				</el-form-item>
				
				<el-form-item label="分配导师" >
					<el-select @change="changeTeacher" style="width: 100%;" multiple  v-model="appointmentsDetail.teacherId" filterable placeholder="请选择" >
						<el-option v-for="item in options2" :key="item.value" :label="item.label"
							:value="item.value">
						</el-option>
					</el-select>
					
					<div v-if="appointmentsDetail.classModel == 2" style="margin-top:10px;" v-for="(item,index) in classTeacherList">
						<div v-if="index == 0">
							<span style="display: inline-block;width:200px;">导师</span>
						<span style="display: inline-block;width:150px;">超时时间(小时)</span>
						</div>
						<span style="display: inline-block;width:200px;">{{item.name}}</span>
						<el-input-number @change="$forceUpdate()"  :min="1" :max="120" label="" v-model="item.classModelHours" style="width: 150px;" ></el-input-number>
					</div>
					
					
				</el-form-item>
				
				
				
				<div style="text-align:center;">
					<!-- 创建课节信息按钮 -->
					<el-button :disabled="!ifSubmit" style="color: white" type="primary"
						@click="agreeingClassAppointment()" round icon="el-icon-success">确认申请</el-button>
				</div>
			</el-form>
			
			
		</el-dialog>
		
		<el-dialog  width="70%" title="选择上课倾向时间" :visible.sync="studentTimeMode" :close-on-press-escape="false" :close-on-click-modal="false" :before-close="handleClose">
				  <el-button v-if="!ifShift" :disabled="!ifSubmit"  style="margin-bottom: 10px;display: inline-block;"
				  	@click="ifShift = true" round  size="small">开启范围选择</el-button>
				  <el-button v-if="ifShift" :disabled="!ifSubmit"  style="margin-bottom: 10px;display: inline-block;"
				  	@click="ifShift = false,shiftNumber = 1" round size="small">关闭范围选择</el-button>
				  
				  <div v-if="ifShift" style="margin-bottom: 10px;display: inline-block;margin-left: 15px;">
					  <div v-if="shiftNumber == 1"><el-tag effect="plain" type="info"><i class="el-icon-success"></i> 选择开始时间</el-tag> — <el-tag type="info" effect="plain"><i class="el-icon-success"></i>选择结束时间</el-tag></div>
					  <div v-if="shiftNumber == 2"><el-tag  effect="plain" type="success"><i class="el-icon-success"></i>选择开始时间</el-tag> — <el-tag type="info" effect="plain"><i class="el-icon-success"></i>选择结束时间</el-tag></div>
				  </div>
				
			      <div style="overflow-x:auto;white-space:nowrap;height:400px;">
				  <div style="display:inline-block;vertical-align: top;" v-for="(dateItem,index) in time" >
			        <div  v-for="(timeItem,itemIndex) in dateItem" >
			          <div style="height:30px;width:175px;">
			            <div style="background:#67C23A;border:1px solid #E4E7ED;color:white;font-weight:bold;padding:5px;font-size:12.5px;" v-if="itemIndex == 0">{{timeItem.name}}</div>
			            <div style="font-size:12.5px;position:relative;margin-top:5px;margin-bottom:5px;" v-if="itemIndex != 0">
						 <el-checkbox-group @change="changeTime(timeItem.name)" v-model="timeItem.checked" :disabled="timeItem.disabled"  size="small">
						  <el-checkbox-button size="mini"  :label="timeItem.name" ></el-checkbox-button>
						   </el-checkbox-group>
			            </div>
			          </div>
			        </div>
			      </div>
				  </div>
				  <div style="text-align: center;margin-top:10px;">
				  	<el-button  size="small"
				  		type="primary" @click="checkStudentTime" icon="el-icon-success" round> 确认上课倾向时间 </el-button>
				  </div>
				
		</el-dialog>
		

		
		
		<el-switch style="margin-left:5px;" size="small" @change="searchUser" v-model="ifPek" active-text="(DFW)" inactive-text="(PEK)">
		</el-switch>
		
		
		
		<el-select @change="searchUser" style="margin-top:10px;margin-left:5px;width: 130px;" clearable  size="small" v-model="courseType" filterable placeholder="选择类型筛选">
		    <el-option
		      v-for="item in courseTypeList"
		      :key="item"
		      :label="item"
		      :value="item">
		    </el-option>
		  </el-select>
		
		<el-select @change="searchUser" style="margin-top:10px;margin-left:5px;" clearable  size="small" v-model="courseId" filterable placeholder="选择课程筛选">
		    <el-option
		      v-for="item in courseList"
		      :key="item.id"
		      :label="item.courseName"
		      :value="item.id">
		    </el-option>
		  </el-select>
		  
		  <el-select @change="searchUser" style="margin-top:10px;margin-left:5px;" clearable  size="small" v-model="headmasterId" filterable placeholder="选择班主任筛选">
		      <el-option
		        v-for="item in headmasterList"
		        :key="item.id"
		        :label="item.headmasterName"
		        :value="item.id">
		      </el-option>
		    </el-select>
			
			<el-select @change="searchUser" style="margin-top:10px;margin-left:5px;" clearable  size="small" v-model="studentId" filterable placeholder="选择学生筛选">
			    <el-option
			      v-for="item in studentList"
			      :key="item.id"
			      :label="item.studentName"
			      :value="item.id">
			    </el-option>
			  </el-select>
			  
			  <el-button :disabled="!ifSubmit" style="margin-top:10px;margin-left:5px;" size="small" round type="primary" @click="toggle">
				  {{ isExpandAll == 1? "展开课程" :isExpandAll == 2? "展开课节" : '全部折叠'}}
			  </el-button>
			  
			  
			<div style="display: inline-block;margin-top:10px;margin-left:20px;">
				<span style="font-weight: bold">合计分值：</span>{{ score }}
			</div>
			  
		<el-button :disabled="!ifSubmit" @click="showAddCourseMode" size="small" round type="success" style="float:right;margin-right:10px;margin-top:10px;">创建课程</el-button>
		<div :style="'height:'+windowHeight+'px;overflow: auto;'">
		<el-table @expand-change="changeStudentId"  :expand-row-keys="studentIdList" row-key="studentId"  ref="studentTable" :data="courses" style="width: 100%;margin-top:10px;" :row-style="{height:'60px'}"  :header-cell-style="{color:'#409EFF'}"
			>
			<el-table-column type="expand" >
			 <template slot-scope="scope">
				 <div>
				 <el-table  @expand-change="changeCourseId"    :expand-row-keys="courseIdList" row-key="id" :data="scope.row.list" style="width: 100%;" :row-style="{height:'60px'}" :header-cell-style="{color:'#67C23A'}" >
						<el-table-column  type="expand">
						      <template slot-scope="scope">
								<div >
								<el-table :data="scope.row.classs" :style="'width: '+(windowWidth-210)+'px;'" max-height="660" :row-style="{height:'60px'}" :header-cell-style="{color:'#E6A23C'}" >
									<el-table-column width="48" prop="" label=""></el-table-column>
									<el-table-column width="200" prop="className" label="课节"></el-table-column>
									<el-table-column width="150" prop="teacherName" label="导师"></el-table-column>
									<el-table-column width="100" label="课节评价">
										<template slot-scope="scope">
											<span  style="color:#E6A23C;" v-if="scope.row.ifRate == 1">未评价</span>
											<span style="color:#409EFF;" v-if="scope.row.ifRate == 2">
												<el-link @click="queryDetailRate(scope.row,1)" style="font-weight: bold;font-size: 15px;" :disabled="!ifSubmit" type="info">
												<div style="width: 40px;display: inline-block;">{{scope.row.avgRate.toFixed(2)}}</div>
												<i style="color:#F56C6C;margin-left:-3px;font-weight:bold;" class="el-icon-warning-outline" v-if="scope.row.minRate > 0 && scope.row.minRate < 3"></i>
												<i style="color:#ffe731;margin-left:-3px;font-weight:bold;" class="el-icon-warning-outline" v-if="scope.row.minRate >= 3 && scope.row.minRate < 4"></i>
												</el-link>
											</span>
										</template>
									</el-table-column>
									<el-table-column width="150" prop="headmasterName" label="班主任"></el-table-column>
									<el-table-column width="180" prop="startTime" label="预定上课时间" >
										<template slot-scope="scope">
											{{getDetailTime(scope.row.startTime)}}
										</template>
									</el-table-column>
									<el-table-column width="180" prop="endTime" label="预定下课时间">
										<template slot-scope="scope">
											{{getDetailTime(scope.row.endTime)}}
										</template>
									</el-table-column>
									<el-table-column width="150" prop="startTime" label="实际上课时间" >
										<template slot-scope="scope">
											{{getDetailTime(scope.row.classFastln)}}
										</template>
									</el-table-column>
									<el-table-column width="150" prop="endTime" label="实际下课时间">
										<template slot-scope="scope">
											{{getDetailTime(scope.row.classLastout)}}
										</template>
									</el-table-column>
									<el-table-column width="120" prop="classActualDuration" label="实际时长"></el-table-column>
									<el-table-column width="120" prop="billDuration" label="计费时长"></el-table-column>
									<el-table-column width="120" prop="cny" label="人民币额度"></el-table-column>
									<el-table-column width="120" prop="usd" label="美元额度"></el-table-column>
									<el-table-column width="120" label="课节类型">
										<template slot-scope="itemScope">
											<span v-if="itemScope.row.isFree == 0">正常课节</span>
											<span v-if="itemScope.row.isFree == 1">赠送课节</span>
										</template>
									</el-table-column>
									
									<el-table-column width="80" label="课节状态">
										<template slot-scope="itemScope">
											<span style="color:#409EFF;" v-if="itemScope.row.classState == 0">历史信息</span>
											<span style="color:#409EFF;" v-if="itemScope.row.classState == 1">待上课</span>
											<span style="color:#E6A23C;" v-if="itemScope.row.classState == 2">已结束</span>
											<!-- <span style="color:#67C23A;" v-if="itemScope.row.classState == 3">已打分</span> -->
										</template>
									</el-table-column>
									
									<el-table-column width="180" fixed="right" label="操作">
										<template slot-scope="itemScope">
											<el-tooltip class="item" effect="dark" content="评价详情" placement="top-start">
											
												<el-button 
												:style="'background-color:'+((itemScope.row.minRate >= 3 && itemScope.row.minRate < 4)?'#ffe731':((itemScope.row.minRate > 0 && itemScope.row.minRate < 3)?'#F56C6C':((itemScope.row.minRate >= 4)?'#67C23A':'')))" 
												circle size="small" icon="el-icon-search" v-if="itemScope.row.className != ''" @click="queryDetailRate(itemScope.row,1)" :disabled="!ifSubmit" >
											
											</el-button>
											</el-tooltip>
											
											<el-tooltip class="item" effect="dark" content="修改课节" placement="top-start">
												<el-button circle icon="el-icon-edit" size="small" v-if="itemScope.row.className != ''" @click="basicInformationPopUpInformation(itemScope.row)" :disabled="!ifSubmit" type="primary"></el-button>
											</el-tooltip>
											
											<el-tooltip v-if="itemScope.row.classState == 1" class="item" effect="dark" content="修改预定时间" placement="top-start">
												<el-button circle icon="el-icon-edit" size="small" v-if="itemScope.row.className != ''" @click="changeStartTime(itemScope.row)" :disabled="!ifSubmit" type="success"></el-button>
											</el-tooltip>
											
											<el-tooltip class="item" effect="dark" content="删除课节" placement="top-start">
												<el-button circle icon="el-icon-close" size="small" v-if="itemScope.row.className != ''" @click="del(itemScope.row.classId)" :disabled="!ifSubmit" type="info"></el-button>
											</el-tooltip>
											
											
										</template>
									</el-table-column>
								</el-table>
								</div>
								<div style="border-top:4px dashed #E6A23C;margin-top:5px;margin-bottom:5px;"></div>
						      </template>
						    </el-table-column>
						
						<el-table-column width="200" prop="courseName" label="课程"></el-table-column>
						<el-table-column width="150" prop="headmasterName" label="班主任" ></el-table-column>
						<el-table-column prop="totalDuration" label="合同开始时间">
							<template slot-scope="scope">
								{{getContractTime(scope.row.courseStartTime)}}
							</template>
						</el-table-column>
						<el-table-column  prop="totalDuration" label="合同结束时间">
							<template slot-scope="scope">
								{{getContractTime(scope.row.courseEndTime)}}
							</template>
						</el-table-column>
						<el-table-column prop="" label="课程状态">
							<template slot-scope="scope">
								<span v-if="scope.row.serviceStateId == 1">服务中</span>
								<span v-if="scope.row.serviceStateId == 2">服务中-可内推</span>
								<span v-if="scope.row.serviceStateId == 3">初步成功</span>
								<span v-if="scope.row.serviceStateId == 4">暂停中</span>
								<span v-if="scope.row.serviceStateId == 5">失败退款</span>
								<span v-if="scope.row.serviceStateId == 6">成功完结</span>
								<span v-if="scope.row.serviceStateId == 7">成功内推</span>
							</template>
						</el-table-column>
						<el-table-column label="ClassIn状态">
							<template slot-scope="scope">
								<span style="color:#409EFF;" v-if="scope.row.courseState == 0">历史信息</span>
								<span style="color:#409EFF;" v-if="scope.row.courseState == 1">进行中</span>
								<span style="color:#E6A23C;" v-if="scope.row.courseState == 2">已结束</span>
								<!-- <span style="color:#67C23A;" v-if="scope.row.courseState == 3">已打分</span> -->
							</template>
						</el-table-column>
						<el-table-column label="优评评价">
							<template slot-scope="scope">
								<span  style="color:#E6A23C;" v-if="scope.row.courseIfRate == 1">未评价</span>
								<span style="color:#409EFF;" v-if="scope.row.courseIfRate == 2">
									<el-link @click="queryDetailRate(scope.row,2)" style="font-weight: bold;font-size: 15px;" :disabled="!ifSubmit" type="info">
										<div style="width: 40px;display: inline-block;">{{scope.row.courseAvgRate.toFixed(2)}}</div>
									<i style="color:#F56C6C;margin-left:-3px;font-weight:bold;" class="el-icon-warning-outline" v-if="scope.row.courseMinRate > 0 && scope.row.courseMinRate < 3"></i>
									<i style="color:#ffe731;margin-left:-3px;font-weight:bold;" class="el-icon-warning-outline" v-if="scope.row.courseMinRate >= 3 && scope.row.courseMinRate < 4"></i>
									</el-link>
								</span>
							</template>
						</el-table-column>
						<el-table-column label="分值">
							<template slot-scope="scope">
								{{scope.row.score}}
							</template>
						</el-table-column>
						
						<el-table-column width="250"  label="操作">
							<template slot-scope="scope">
								<el-tooltip class="item" effect="dark" content="评价详情" placement="top-start">
									<el-button 
									:style="'background-color:'+((scope.row.courseMinRate >= 3 && scope.row.courseMinRate < 4)?'#ffe731':((scope.row.courseMinRate > 0 && scope.row.courseMinRate < 3)?'#F56C6C':((scope.row.courseMinRate >= 4)?'#67C23A':'')))" 
									circle size="small" icon="el-icon-search" @click="queryDetailRate(scope.row,2)" :disabled="!ifSubmit">
									</el-button>
								</el-tooltip>
								<el-tooltip class="item" effect="dark" content="修改课程" placement="top-start">
									<el-button circle size="small" icon="el-icon-edit" @click="updateCourse(scope.row.id)" style="margin-right:8px;" :disabled="!ifSubmit" type="warning"></el-button>
								</el-tooltip>
								<span v-if="scope.row.courseState == 0 || scope.row.courseState == 1">
									<el-tooltip class="item" effect="dark" content="创建约课" placement="top-start">
									    <el-button circle icon="el-icon-plus" size="small" @click="showAppointment(scope.row)"  :disabled="!ifSubmit" type="primary"></el-button>
									</el-tooltip>
										
									<el-tooltip class="item" effect="dark" content="创建课节" placement="top-start">
										<el-button circle icon="el-icon-plus" size="small" @click="showAddClassMode(scope.row)" :disabled="!ifSubmit" type="success"></el-button>
									</el-tooltip>
									
									<el-tooltip v-if="scope.row.serviceStateId == 5 || scope.row.serviceStateId == 6 || scope.row.serviceStateId == 7" class="item" effect="dark" content="结束课程" placement="top-start">
										<el-button circle size="small" icon="el-icon-close" @click="checkEndCourse(scope.row)" style="margin-right:8px;" :disabled="!ifSubmit" type="info"></el-button>
									</el-tooltip>
									<el-tooltip v-if="scope.row.serviceStateId == 1 || scope.row.serviceStateId == 2 || scope.row.serviceStateId == 3 || scope.row.serviceStateId == 4" class="item" effect="dark" content="只有失败退款，成功完结，成功内推才可以结束课程" placement="top-start">
										<el-button circle size="small" icon="el-icon-close" style="margin-right:8px;" :disabled="!ifSubmit" type="info"></el-button>
									</el-tooltip>
								</span>
								
								
								
								
								<!-- <el-link @click="showUpdCourseMode(scope.row)" style="margin-right:8px;" :disabled="!ifSubmit" type="warning">修改信息</el-link> -->
							</template>
							
						</el-table-column>
				 </el-table>
				 <div style="border-top:4px dashed #67C23A;margin-top:5px;margin-bottom:5px;"></div>
				 </div>
			 </template>
		    </el-table-column>
			<el-table-column  prop="studentName" label="学生"></el-table-column>
			<el-table-column  prop="totalDuration" label="最新课程总课时"></el-table-column>
			<el-table-column  prop="leftDuration" label="最新课程剩余课时"></el-table-column>
			<el-table-column  prop="totalDuration" label="最新课程开始时间">
				<template slot-scope="scope">
					{{getContractTime(scope.row.contractStartTime)}}
				</template>
			</el-table-column>
			<el-table-column prop="totalDuration" label="最新课程结束时间">
				<template slot-scope="scope">
					{{getContractTime(scope.row.contractEndTime)}}
				</template>
			</el-table-column>
			<el-table-column prop="sumScore" label="合计分值">
				<template slot-scope="scope">
					{{scope.row.sumScore}}
				</template>
			</el-table-column>
			
			<el-table-column prop="studentName" label="性别">
				<template slot-scope="scope">
					<span v-if="scope.row.gender == 1">Male</span>
					<span v-if="scope.row.gender == 2">Female</span>
				</template>
			</el-table-column>
			<el-table-column prop="timePeriodEnd" label="毕业时间"></el-table-column>
			<el-table-column prop="studentName" label="求职意向">
				<template slot-scope="scope">
					  <el-popover v-if="scope.row.works != null && scope.row.works.length != 0 && scope.row.works[0].works != null"
					    placement="left"
					    title=""
					    width="300"
					    trigger="hover"
					    >
						<div v-for="(item,index) in scope.row.works" :style="'margin-bottom:2.5px;padding-bottom:2.5px;'+(index != (scope.row.works.length -1)?'border-bottom:1px solid #DCDFE6;':'')">
							{{item.works}}
						</div>
						<i class="el-icon-warning-outline" style="cursor: pointer;" slot="reference"></i>
					  </el-popover>
					
				</template>
			</el-table-column>
			
			
			
			 
		</el-table>
		</div>
		<el-pagination style="margin-top:5px;" @size-change="handleSizeChange" @current-change="handleCurrentChange"
		 :current-page="currentPage" :page-sizes="[10, 20, 40]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
		 :total="total">
		</el-pagination>
	</div>
</template>

<script>
	import utils from "@/utils";
	export default {
		data() {
			return {
				score:0,
				 windowWidth:innerWidth,
				 pickerOptions:{
					  disabledDate (time) {
						return time.getTime() < Date.now()-1*24*3600*1000;
					  }
				  },
				ifSubmit:true,
				windowHeight: window.innerHeight - 177,
				
				courses:[],
				total:0,
				currentPage: 1,
				pageSize: 10, //每页显示几条数据
				courseId:null,
				headmasterId:null,
				studentId:null,
				ifPek:false,
				courseType:"",
				courseTypeList:["LP","DP","EP","UP","PP","GP","CP","LH"],
				
				courseList:[],
				
				headmasterList:[],
				studentList:[],
				teacherList:[],
				timezone:[],
				
				addCourseMode:false,
				updCourseMode:false,
				editCourseDetail:{durationType:1,totalDuration:0,},
				
				addClassMode:false,
				editClassDetail:{
					number:60,
				},
				
				appointmentsDetail:{
					demandInformation:[],
					file:[
						//name,content
					],
					timezone:null,
					teacherTime:{},
					teacherId:[],
					classHours:60
				},
				classType:[],
				appointmentsDialog:false,
				studentTime:[],
				studentShowTime:[],
				studentTimeMode:false,
				ifShift:false,
				shiftNumber:1,
				shiftStartTime:"",
				time:[],
				classTeacherList:[],
				gridsearch2 : {
					value: "",
					label: ""
				},
				options2:[],
				
				classRateDialog:false,
				classRateTypes:0,
				classRateDetail:{},
				
				classDetail:{},
				classDetailDialog:false,
				changeClassTimelog:false,
				
				isExpandAll: 1,
				
				expands:[],
				expands2:[],
				
				  getRowKeys1(row) {
					return row.studentId
				  },
			  
				getRowKeys2(row) {
				  return row.id
				},
				expands:[],
				
				studentIdList:[],
				
				courseIdList:[],
			
				defaultStudentIdList:[],
				
				defaultCourseIdList:[],
				rateIndex:"first"
			};
		},
		methods: {
			cumputerTime(time){
				if(time.indexOf("0001") == -1){
					return utils.getDetailTime(time,4);
				}else{
					return null;
				}
			},
			changeStudentId(row,expandedRows){
				let defaultStudentIdList = this.defaultStudentIdList;
				if(expandedRows.length>0){
					defaultStudentIdList.push(row.studentId);
				}else{
					defaultStudentIdList = defaultStudentIdList.filter((x) => x !== row.studentId);
				}
				this.defaultStudentIdList = defaultStudentIdList;
			},
			changeCourseId(row,expandedRows){
				let defaultCourseIdList = this.defaultCourseIdList;
				if(expandedRows.length>0){
					defaultCourseIdList.push(row.id);
				}else{
					defaultCourseIdList = defaultCourseIdList.filter((x) => x !== row.id);
				}
				this.defaultCourseIdList = defaultCourseIdList;
			},
			handleClose(done) {
				for (let i = 0; i < this.time.length; i++) {
				 for (let c = 0; c < this.time[i].length; c++) {
					this.time[i][c].checked = false;
				 } 
				}
				this.studentTimeMode = false;
			},
			changeTime(e){
				
				if(this.ifShift){
					
					if(this.shiftNumber == 1){
						this.shiftStartTime = e;
						this.shiftNumber = 2;
					}else{
						for (let i = 0; i < this.time.length; i++) {
						 for (let c = 0; c < this.time[i].length; c++) {
							if(this.time[i][c].name.length > 16){
								let date = new Date(this.time[i][c].name.substring(0,17));
								let startDate = new Date(this.shiftStartTime.substring(0,17));
								let endDate = new Date(e.substring(0,17));
								if(date.getDate() >= startDate.getDate() && date.getDate() <= endDate.getDate() && this.time[i][c].disabled == false){
									if(date.getHours() >= startDate.getHours() && date.getHours() <= endDate.getHours()){
										this.time[i][c].checked = true;
									}
								}
								
							}
						 } 
						}
						
						this.ifShift = false;
						this.shiftNumber = 1;
						this.shiftStartTime = "";
					}
					
				}
				
			},
			changeClassTime(e){
				if(this.classDetail.classFastln != null && this.classDetail.classLastout != null){
					let date1 = new Date(this.classDetail.classFastln).getTime();
					let date2 = new Date(this.classDetail.classLastout).getTime();
					this.classDetail.billDuration = (date2 - date1)/60/1000;
				}
			},
			del(id){
				//再次确认提示
				this.$confirm("确定删除此信息吗？", "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
				}).then(() => {
					utils.requestGet("删除课节信息", "classes/deleteClass", {
							id: id,
						}).then((data) => {
							console.log(data)
							this.$message({
								showClose: true,
								message: "删除成功！",
								type: "success",
							});
							this.searchUser();
						});
				});
			},
			// 点击切换
			toggle() {
				if(this.isExpandAll == 3){
					//this.collapseAll();
					this.studentIdList = [];
					this.courseIdList = [];
					this.isExpandAll = 1;
				}else 
				if(this.isExpandAll == 1){
					//this.expandAll();
					let studentIdList = [];
					for(let s=0;s<this.courses.length;s++){
						studentIdList.push(this.courses[s].studentId);
					}
					this.studentIdList = studentIdList;
					this.defaultStudentIdList = this.studentIdList;
					this.isExpandAll = 2;
				}else 
				if(this.isExpandAll == 2){
					//this.expandAll();
					let studentIdList = [];
					let courseIdList = [];
					for(let s=0;s<this.courses.length;s++){
						studentIdList.push(this.courses[s].studentId);
						for(let c=0;c<this.courses[s].list.length;c++){
							courseIdList.push(this.courses[s].list[c].id);
						}
					}
					this.studentIdList = studentIdList;
					this.courseIdList = courseIdList;
					this.defaultStudentIdList = this.studentIdList;
					this.defaultCourseIdList = this.courseIdList;
					this.isExpandAll = 3;
				}
				
			},
			expandAll () {
				console.log("展开")
			  let els = document.getElementsByClassName('el-table__expand-icon')
			  if (this.courses.length !== 0 && els.length !== 0) {
				for (let j = 0; j < els.length; j++) {
				  els[j].classList.add('dafult')
				}
				if (this.$el.getElementsByClassName('el-table__expand-icon--expanded')) {
				  const open = this.$el.getElementsByClassName('el-table__expand-icon--expanded')
				  for (let j = 0; j < open.length; j++) {
					open[j].classList.remove('dafult')
				  }
				  const dafult = this.$el.getElementsByClassName('dafult')
				  for (let a = 0; a < dafult.length; a++) {
					dafult[a].click()
				  }
				}
			  }
			},
			collapseAll () {
				console.log("折叠")
			  if (this.courses.length !== 0) {
				const elsopen = this.$el.getElementsByClassName('el-table__expand-icon--expanded')
				if (this.$el.getElementsByClassName('el-table__expand-icon--expanded')) {
				  for (let i = 0; i < elsopen.length; i++) {
					elsopen[i].click()
				  }
				}
			  }
			},
			getFile(){
				var that = this;
				let fileCount = document.getElementById('topFile').files.length;
				if(fileCount == 0){
					this.$message({
						message: '未选择文件，请重新选择',
						type: "warning",
						duration: 2000
					});
					return;
				}
				let inputFile = document.getElementById('topFile').files[0];
				let formData = new FormData()
				formData.append('file',inputFile)
				utils.requestUploadPost("上传文件", "file/headmasterUpload", formData).then((data) => {
					console.log(data)
					this.$message({
						message: '上传成功，请继续操作',
						type: "success",
						duration: 2000
					});
					this.appointmentsDetail.file.push({
						name:inputFile.name,
						url:data,
					});
				}).catch((errMsg) => {
					this.$message({
						message: '上传失败，请检查网络连接后，重新上传',
						type: "warning",
						duration: 2000
					});
				});
			},
			delFile(index){
				this.appointmentsDetail.file.splice(index,1);
			},
			choiceImg(index){
				document.getElementById('topFile').click();
			},
			confirmTime2() {
				this.$confirm("确认修改此信息吗？", "提示", {
					confirmButtonText: "确定修改",
					cancelButtonText: "取消",
					type: "success",
				}).then(() => {
				this.ifSubmit = false;
				let startTime = this.classDetail.startTime;
				let endTime = this.classDetail.endTime;
				let timezoneNumber = new Date(this.classDetail.startTime).getTimezoneOffset() / -60;
				startTime = this.getLocalTime(startTime,timezoneNumber);
				endTime = this.getLocalTime(endTime,timezoneNumber);
				//转换为中国时间
				startTime = this.getLocalTime2(startTime,8);
				endTime = this.getLocalTime2(endTime,8);
				
				//获取当天汇率
				utils.getUSDRate_time(utils.getDetailTime(startTime,4)).then((data) => {
					this.classDetail.currencyRate = data;
					
					//获取时间戳
					this.classDetail.startTimeUnixEpoch = Date.parse(new Date(startTime)).toString().substring(0,10);
					this.classDetail.endTimeUnixEpoch = Date.parse(new Date(endTime)).toString().substring(0,10);
					
					//计算时间戳时差
					let timezoneCount = 8 - timezoneNumber;
					if(timezoneCount != 0){
						this.classDetail.startTimeUnixEpoch = (parseInt(this.classDetail.startTimeUnixEpoch) - (timezoneCount * 3600)).toString();
						this.classDetail.endTimeUnixEpoch = (parseInt(this.classDetail.endTimeUnixEpoch) - (timezoneCount * 3600)).toString();
					}
					
					let detail = JSON.parse(JSON.stringify(this.classDetail));
					detail.startTime = startTime;
					detail.endTime = endTime;
					
					utils.requestPost("修改课节预定时间", "classes/updateClassStartTime",detail)
						.then((data) => {
						if(data.error_info.errno == 1){
							this.$message({
								message: '修改预定时间成功',
								type: "success",
								duration: 2000
							});
							this.changeClassTimelog = false;
							this.getCourses();
						}else{
							this.$message({
								message: "修改失败："+data.error_info.error,
								type: "warning",
								duration: 5000
							});
						}	
						this.ifSubmit = true;
					});
				})
					
				});
			},
			confirmTime() {
				this.$confirm("确认修改此信息吗？", "提示", {
					confirmButtonText: "确定修改",
					cancelButtonText: "取消",
					type: "success",
				}).then(() => {
					this.classDetail.ifPek = this.ifPek;
					utils.requestPost("修改课节基本信息", "classes/updateClassTime", this.classDetail)
						.then((data) => {
						//重新查询
						this.getCourses();
						this.classDetailDialog = false;
						this.$message({
							showClose: true,
							message: "修改成功！",
							type: "success",
						});
					});
				});
			},
			basicInformationPopUpInformation(detail) {
				this.classDetail = JSON.parse(JSON.stringify(detail));
				if(this.classDetail.classFastln.indexOf("0001") != -1){
					this.classDetail.classFastln = null;
				}else{
					this.classDetail.classFastln = utils.getDetailTime(this.classDetail.classFastln,1);
				}
				if(this.classDetail.classLastout.indexOf("0001") != -1){
					this.classDetail.classLastout = null;
				}else{
					this.classDetail.classLastout = utils.getDetailTime(this.classDetail.classLastout,1);
				}
				this.classDetailDialog = true;
			},
			changeStartTime(detail){
				this.classDetail = JSON.parse(JSON.stringify(detail));
				this.classDetail.startTime = null;
				this.classDetail.endTime = null;
				this.changeClassTimelog = true;
			},
			queryDetailRate(detail,types){
				utils.requestGet("查询课节评分详情", "infos/getRateDetails", {
					types:types,
					id:types == 1?detail.classId:detail.id
				}).then((data) => {
					this.classRateDialog = true;
					for(let i=0;i<data.length;i++){
						data[i].details = JSON.parse(data[i].details);
					}
					this.classRateDetail = data;
					this.classRateTypes = types;
				})
			},
			handle() {
				var startAt = new Date(this.editClassDetail.startTime) * 1000 /1000;
				if(startAt < Date.now()) {
					this.$message({
						message: '请选择当前时间以后的时间，选择时间已自动变更为当前时间。',
						type: 'info',
					})
					this.editClassDetail.startTime = new Date();
				}
			},
			getDetailTime(time){
				if(time.indexOf("0001-01-01") != -1){
					return "";
				}else{
					return utils.getDetailTime(time,6);
				}
			},
			getContractTime(time){
				if(time.indexOf("0001-01-01") != -1){
					return "";
				}else{
					return utils.getDetailTime(time,4);
				}
			},
			updateCourse(courseId){
				//页面跳转至新窗口并携带参数 主键
				let link = this.$router.resolve({
					path: "/CourseInformationOperation/" + courseId,
				});
				window.open(link.href, "_blank"); //打开新窗口
			},
			changeClassType(detail){
				this.$forceUpdate();
				for(let i=0;i<this.classType.length;i++){
					if(this.classType[i].id == detail){
						this.appointmentsDetail.className = this.classType[i].content;
						break;
					}
				}
			},
			agreeingClassAppointment(){
				if(this.studentTime.length == 0){
					this.$message({
						message: '请至少选择一个上课倾向时间',
						type: 'info',
					})
					return;
				}
				if(this.appointmentsDetail.classNameIndex == null){
					this.$message({
						message: '请选择课节名称后再继续',
						type: 'info',
					})
					return;
				}
				if(this.appointmentsDetail.classNameIndex == 1 &&  (this.appointmentsDetail.className == null || this.appointmentsDetail.className.length == 0)){
					this.$message({
						message: '请输入课节名称后再继续',
						type: 'info',
					})
					return;
				}
				if(this.appointmentsDetail.classNameIndex != 1){
					for(let i=0;i<this.classType.length;i++){
						if(this.classType[i].id == this.appointmentsDetail.classNameIndex){
							this.appointmentsDetail.className = this.classType[i].content;
							break;
						}
					}
					
				}
				if(this.appointmentsDetail.classHours <= 0){
					this.$message({
						message: '请输入预计课节时长后再继续',
						type: 'info',
					})
					return;
				}
				if(this.appointmentsDetail.teacherId.length == 0){
					this.$message({
						message: '请分配导师后再继续',
						type: 'info',
					})
					return;
				}
				this.ifSubmit = false;
				let detail = JSON.parse(JSON.stringify(this.appointmentsDetail));
				detail.file = JSON.stringify(detail.file);
				detail.demandInformation = JSON.stringify(detail.demandInformation).replace(new RegExp("\r\n", "gm"), "brHH");
				detail.name = utils.getAccountName();
				if(detail.classModel == 1){
					for(let i=0;i<this.classTeacherList.length;i++){
						this.classTeacherList[i].classModelHours = detail.classModelHours;
					}
				}
				let studentTime = this.studentTime;
				for(let i=0;i<studentTime.length;i++){
					studentTime[i] = utils.getUTCTime(studentTime[i].substring(0,16));
				}
				detail.studentTime = JSON.stringify(studentTime);
				detail.teacherList = this.classTeacherList;
				utils.requestPost("创建约课", "MessageAlert/createClassAppointment",detail).then((data) => {
					this.$message({
						message: '创建约课成功，等待导师填写可选上课时间',
						type: "success",
						duration: 2000
					});
					this.appointmentsDialog = false;
					this.ifSubmit = true;
				});
				
			},
			checkStudentTime(){
				let time = [];
				for (let i = 0; i < this.time.length; i++) {
				 for (let c = 0; c < this.time[i].length; c++) {
					if(this.time[i][c].checked){
						time.push(this.time[i][c].name);
					}
				 } 
				}
				this.studentTime = time;
				this.studentShowTime = this.timeGroup(this.studentTime);
				this.studentTimeMode = false;
			},
			addStudentTime(){
				this.ifShift = false;
				this.shiftNumber = 1;
				this.shiftStartTime = "";
				for (let i = 0; i < this.time.length; i++) {
				 for (let c = 0; c < this.time[i].length; c++) {
					if(this.time[i][c].name.length == 24){
						let date1 = new Date(this.time[i][c].name.substring(0,16));
						let date2 = new Date();
						date2.setTime(new Date().getTime()-3600000);
						if(date2.getTime() > date1.getTime()){
							this.time[i][c].disabled = true;
						}
					} 
					for (let s = 0; s < this.studentTime.length; s++) {
						if(this.time[i][c].name == this.studentTime[s]){
							this.time[i][c].checked = true;
						}
					}
				 } 
				}
				this.studentTimeMode = true;
			},
			showAppointment(detail){
				let classType = [];
				this.appointmentsDetail = {
					demandInformation:[],
					file:[
						//name,content
					],
					timezone:null,
					teacherTime:{},
					teacherId:[],
					classHours:60
				};
				//查询约课需要的信息
				utils.requestGet("查询约课需要的信息", "course/checkClassAppointmentsStudent",{email:detail.email}).then((data) => {
					if(data.studentCount > 0){
						for(let i=0;i<data.types.length;i++){
							if(data.types[i].types == 4){
								classType.push(data.types[i]);
							}
							if(data.types[i].types == 5){
								this.appointmentsDetail.demandInformation = JSON.parse(data.types[i].content);
							}
						}
						this.classType = classType;
						
						//默认为第一个课程
						this.appointmentsDetail.courseName = detail.courseName;
						this.appointmentsDetail.courseId = detail.id;
						this.appointmentsDetail.email = detail.email;
						this.appointmentsDetail.studentName = detail.studentName;
						this.appointmentsDetail.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
						this.appointmentsDetail.timezoneNumber = new Date().getTimezoneOffset() / -60;
						this.appointmentsDetail.classModelHours = 120;
						this.appointmentsDetail.record = 1;
						this.appointmentsDetail.recordScene = 0;
						this.appointmentsDetail.live = 0;
						this.appointmentsDetail.replay = 0;
						this.appointmentsDetail.watchByLogin = 0;
						this.appointmentsDetail.classModel = 1;
						this.appointmentsDetail.classType = 0;
						this.appointmentsDetail.classNameIndex = 1;
						
						this.appointmentsDialog = true;
					}else{
						this.$message({
							message: '此学生在StudentPortal系统中不存在，请先在StudentPortal系统中注册',
							type: 'info',
						})
					}
					
				})
				
			},
			changeRecord2(){
				this.$forceUpdate();
				if(this.appointmentsDetail.record == 0 && this.appointmentsDetail.recordScene == 0){
					this.appointmentsDetail.live = 0;
					this.appointmentsDetail.replay = 0;
				}
				if(this.appointmentsDetail.live == 0 && this.appointmentsDetail.replay == 0){
					this.appointmentsDetail.watchByLogin = 0;
				}
			},
			changeRecord(){
				if(this.editClassDetail.record == 0 && this.editClassDetail.recordScene == 0){
					this.editClassDetail.live = 0;
					this.editClassDetail.replay = 0;
				}
				if(this.editClassDetail.live == 0 && this.editClassDetail.replay == 0){
					this.editClassDetail.watchByLogin = 0;
				}
			},
			changeSelect(detail){
				this.$forceUpdate();
				for(let i=0;i<this.teacherList.length;i++){
					if(this.teacherList[i].id == detail){
						this.editClassDetail.types = this.teacherList[i].types;
						this.editClassDetail.classRate = this.teacherList[i].teacherRate;
						break;
					}
				}
				
			},
			checkAddClass(){
				if(this.editClassDetail.classNameIndex == null){
					this.$message({
						message: '请选择课节名称后再继续',
						type: 'info',
					})
					return;
				}
				if(this.editClassDetail.classNameIndex == 1 &&  (this.editClassDetail.className == null || this.editClassDetail.length == 0)){
					this.$message({
						message: '请输入课节名称后再继续',
						type: 'info',
					})
					return;
				}
				if(this.editClassDetail.classNameIndex != 1){
					for(let i=0;i<this.classType.length;i++){
						if(this.classType[i].id == this.editClassDetail.classNameIndex){
							this.editClassDetail.className = this.classType[i].content;
							break;
						}
					}
					
				}
				if(this.editClassDetail.startTime == null){
					this.$message({
						message: '请选择上课时间后再继续',
						type: 'info',
					})
					return;
				}
				if(this.editClassDetail.teacherId == null){
					this.$message({
						message: '请选择导师后再继续',
						type: 'info',
					})
					return;
				}
				for(let i=0;i<this.teacherList.length;i++){
					if(this.teacherList[i].id == this.editClassDetail.teacherId){
						this.editClassDetail.teacherUid = this.teacherList[i].uid;
						break;
					}
				}
				
				this.ifSubmit = false;
				this.editClassDetail.timezoneNumber = new Date(this.editClassDetail.startTime).getTimezoneOffset() / -60;
				let startTime = this.editClassDetail.startTime;
				startTime = this.getLocalTime(startTime,this.editClassDetail.timezoneNumber);
				//转换为中国时间
				startTime = this.getLocalTime2(startTime,8);
				this.editClassDetail.courseId = this.editCourseDetail.id;
				utils.getUSDRate_time(utils.getDetailTime(startTime,4)).then((data) => {
					this.editClassDetail.currencyRate = data;
					let time = new Date(startTime);
					this.editClassDetail.endTime = utils.getDetailTime(time.setMinutes(time.getMinutes() + this.editClassDetail.number),6);
					this.editClassDetail.duration = this.editClassDetail.number;
					this.editClassDetail.startTimeUnixEpoch = Date.parse(new Date(startTime)).toString().substring(0,10);
					this.editClassDetail.endTimeUnixEpoch = Date.parse(new Date(this.editClassDetail.endTime)).toString().substring(0,10);
					let timezoneCount = 8 - this.editClassDetail.timezoneNumber;
					if(timezoneCount != 0){
						this.editClassDetail.startTimeUnixEpoch = (parseInt(this.editClassDetail.startTimeUnixEpoch) - (timezoneCount * 3600)).toString();
						this.editClassDetail.endTimeUnixEpoch = (parseInt(this.editClassDetail.endTimeUnixEpoch) - (timezoneCount * 3600)).toString();
					}
					let detail = JSON.parse(JSON.stringify(this.editClassDetail));
					detail.startTime = startTime;
					utils.requestPost("课程管理创建课节", "classes/addClass",detail).then((data) => {
						if(data.error_info.errno == 1){
							this.$message({
								message: '创建课节成功',
								type: "success",
								duration: 2000
							});
							this.addClassMode = false;
							this.getCourses();
						}else{
							this.$message({
								message: "创建失败："+data.error_info.error,
								type: "warning",
								duration: 5000
							});
						}
						this.ifSubmit = true;
					})
				})
			},
			getLocalTime(time,i) {
				if(i>0){
					i = 0-i;
				}else{
					i = (i-i-i);
				}
				let d2 = new Date(time);
				let stampGTM = d2.getTime() + (i*60) * 60 * 1000;
				return utils.getDetailTime(stampGTM,2);
			},
			getLocalTime2(time,i) {
				let d2 = new Date(time);
				let stampGTM = d2.getTime() + (i*60) * 60 * 1000;
				return utils.getDetailTime(stampGTM,2);
			},
			showAddClassMode(detail){
				let classType = [];
				//查询约课需要的信息
				utils.requestGet("查询约课需要的信息", "MessageAlert/getClassAppointmentsTypes",null).then((data) => {
					for(let i=0;i<data.length;i++){
						if(data[i].types == 4){
							classType.push(data[i]);
						}
					}
					this.classType = classType;
					this.addClassMode = true;
				})
				this.editCourseDetail = JSON.parse(JSON.stringify(detail));
				this.editClassDetail = {types:"USD",number:60,classRate:0,record:1,recordScene:0,live:0,replay:0,watchByLogin:0,classType:0,classNameIndex:1};
				this.editClassDetail.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
				this.editClassDetail.timezoneNumber = new Date().getTimezoneOffset() / -60;
				
				
			},
			checkEndCourse(detail){
				this.$confirm('确定结束课程吗？', '提示', {
				  confirmButtonText: '确定',
				  cancelButtonText: '取消',
				  type: 'warning'
				}).then(() => {
				  this.ifSubmit = false;
				  utils.requestGet("课程管理结束课程", "course/endCourse",{
					  courseId:detail.id
				  }).then((data) => {
					if(data.error_info.errno == 1){
						this.$message({
							message: '结束课程成功',
							type: "success",
							duration: 2000
						});
						this.getCourses();
					}else{
						this.$message({
							message: "结束失败："+data.error_info.error,
							type: "warning",
							duration: 5000
						});
					}
				  	this.ifSubmit = true;
				  })
				})
			},
			checkUpdCourse(){
				if(this.editCourseDetail.courseName == null || this.editCourseDetail.courseName.length == 0){
					this.$message({
						message: '请输入课程名称后再继续',
						type: 'info',
					})
					return;
				}
				for(let i=0;i<this.headmasterList.length;i++){
					if(this.headmasterList[i].id == this.editCourseDetail.headmasterId){
						this.editCourseDetail.headmasterUid = this.headmasterList[i].uid;
						break;
					}
				}
				for(let i=0;i<this.studentList.length;i++){
					if(this.studentList[i].id == this.editCourseDetail.studentId){
						this.editCourseDetail.studentUid = this.studentList[i].uid;
						break;
					}
				}
				
				this.ifSubmit = false;
				utils.requestPost("课程管理修改课程", "course/updCourse",this.editCourseDetail).then((data) => {
					if(data.error_info.errno == 1){
						this.$message({
							message: '修改课程成功',
							type: "success",
							duration: 2000
						});
						this.updCourseMode = false;
						this.getCourses();
					}else{
						this.$message({
							message: "修改失败："+data.error_info.error,
							type: "warning",
							duration: 5000
						});
					}
					this.ifSubmit = true;
				})
			},
			showUpdCourseMode(detail){
				this.editCourseDetail = JSON.parse(JSON.stringify(detail));
				//需要移除的学生uid
				this.editCourseDetail.oldStudentUid = this.editCourseDetail.studentUid;
				this.updCourseMode = true;
			},
			checkAddCourse(){
				if(this.editCourseDetail.courseName == null || this.editCourseDetail.courseName.length == 0){
					this.$message({
						message: '请输入课程名称后再继续',
						type: 'info',
					})
					return;
				}
				if(this.editCourseDetail.durationType == 1 && this.editCourseDetail.totalDuration == 0){
					this.$message({
						message: '请输入总课时后再继续',
						type: 'info',
					})
					return;
				}
				if(this.editCourseDetail.studentId == null){
					this.$message({
						message: '请选择学生后再继续',
						type: 'info',
					})
					return;
				}
				if(this.editCourseDetail.headmasterId == null){
					this.$message({
						message: '请选择班主任后再继续',
						type: 'info',
					})
					return;
				}
				
				for(let i=0;i<this.headmasterList.length;i++){
					if(this.headmasterList[i].id == this.editCourseDetail.headmasterId){
						this.editCourseDetail.headmasterUid = this.headmasterList[i].uid;
						break;
					}
				}
				for(let i=0;i<this.studentList.length;i++){
					if(this.studentList[i].id == this.editCourseDetail.studentId){
						this.editCourseDetail.studentUid = this.studentList[i].uid;
						break;
					}
				}
				
				this.ifSubmit = false;
				utils.requestPost("课程管理创建课程", "course/addCourse",this.editCourseDetail).then((data) => {
					if(data.error_info.errno == 1){
						this.$message({
							message: '创建课程成功',
							type: "success",
							duration: 2000
						});
						this.addCourseMode = false;
						this.getCourses();
					}else{
						this.$message({
							message: "创建失败："+data.error_info.error,
							type: "warning",
							duration: 5000
						});
					}
					this.ifSubmit = true;
				})
				
			},
			convertHours(time){
				return utils.convertHours(time);
			},
			showAddCourseMode(){
				this.addCourseMode = true;
				this.editCourseDetail = {durationType:1,totalDuration:0,};
			},
			searchUser(){
				this.currentPage = 1;
				//重新查询
				this.getCourses();
				this.$forceUpdate();
			},
			handleSizeChange: function(size) {
				this.pageSize = size;
				this.getCourses();
			},
			handleCurrentChange: function(currentPage) {
				this.currentPage = currentPage;
				this.getCourses();
			},
			getCourses(){
				this.ifSubmit = false;
				utils.requestPost("课程管理查询课程", "course/getCourses",{
					courseId:((this.courseId == null || this.courseId == "" )?0:this.courseId),
					headmasterId:((this.headmasterId == null || this.headmasterId == "" )?0:this.headmasterId),
					studentId:((this.studentId == null || this.studentId == "" )?0:this.studentId),
					pageSize:this.pageSize,
					page:this.currentPage,
					ifPek:this.ifPek,
					courseType:this.courseType,
				}).then((data) => {
					this.score = data.score;
					if(data.courses.length != 0){
					{
						let list = data.courses;
						//数据分组
						let list2 = [];
						let str = list[0];
						let detail = [list[0]];
						for (let i = 1; i < list.length; i++) {
						  if (list[i].studentName == str.studentName){
							detail.push(list[i]);
						  }else{
							list2.push(detail);
							detail = [list[i]]; 
						  }
						  str = list[i];
						} 
						list2.push(detail);
						for(let i=0;i<list2.length;i++){
							let totalDuration = list2[i][0].totalDuration;
							let leftDuration = list2[i][0].leftDuration;
							list2[i] = {
							contractStartTime:list2[i][0].contractStartTime,
							contractEndTime:list2[i][0].contractEndTime,
							studentName:list2[i][0].studentName,
							studentId:list2[i][0].studentId,
							email:list2[i][0].email,
							totalDuration:(totalDuration == -50000?'+∞':(parseInt(totalDuration/60)+"小时"+parseInt((totalDuration%60))+"分钟"))   ,
							leftDuration:(leftDuration == -50000?'+∞':(parseInt(leftDuration/60)+"小时"+parseInt((leftDuration%60))+"分钟"))   ,
							list:list2[i]};
						}
						data.courses = list2;
					}
					{
						for(let c=0;c<data.courses.length;c++){
							let list = data.courses[c].list;
							//数据分组
							let list2 = [];
							let str = list[0];
							let detail = [list[0]];
							for (let i = 1; i < list.length; i++) {
							  if (list[i].courseName == str.courseName){
								detail.push(list[i]);
							  }else{
								list2.push(detail);
								detail = [list[i]]; 
							  }
							  str = list[i];
							} 
							list2.push(detail);
							for(let i=0;i<list2.length;i++){
								list2[i] = {
									score:list2[i][0].score,
									courseStartTime:list2[i][0].courseStartTime,
									courseEndTime:list2[i][0].courseEndTime,
									serviceStateId:list2[i][0].serviceStateId,
									courseMinRate:list2[i][0].courseMinRate,
									courseAvgRate:list2[i][0].courseAvgRate,
									courseIfRate:list2[i][0].courseIfRate,
									courseName:list2[i][0].courseName,
									studentId:list2[i][0].studentId,
									studentUid:list2[i][0].studentUid,
									id:list2[i][0].id,
									headmasterId:list2[i][0].headmasterId,
									headmasterName:list2[i][0].headmasterName,
									email:list2[i][0].email,
									headmasterUid:list2[i][0].headmasterUid,
									courseState:list2[i][0].courseState,
								classs:(list2[i][0].classId != 0?list2[i]:[])};
							}
							data.courses[c].list = list2;
						}
					}
					
					{
						for(let c = 0;c<data.courses.length;c++){
							let sumScore = 0;
							for(let i = 0;i<data.courses[c].list.length;i++){
								if(data.courses[c].list[i].serviceStateId == 1 || data.courses[c].list[i].serviceStateId == 2){
									sumScore += data.courses[c].list[i].score;
								}
							}
							data.courses[c].sumScore = sumScore;
						}
						
					}
					
					{
						let list = data.userDetailParams;
						//数据分组
						let list2 = [];
						let str = list[0];
						let detail = [list[0]];
						for (let i = 1; i < list.length; i++) {
						  if (list[i].email == str.email){
							detail.push(list[i]);
						  }else{
							list2.push(detail);
							detail = [list[i]]; 
						  }
						  str = list[i];
						} 
						list2.push(detail);
						for(let i=0;i<list2.length;i++){
							
							list2[i] = {
							gender:(list2[i][0] != undefined?list2[i][0].gender:''),
							email:(list2[i][0] != undefined?list2[i][0].email:''),
							timePeriodEnd:(list2[i][0] != undefined?list2[i][0].timePeriodEnd:''),
							list:list2[i]};
						}
						data.userDetailParams = list2;
					}
					
					{
						for(let i=0;i<data.courses.length;i++){
							for(let c=0;c<data.userDetailParams.length;c++){
								if(data.courses[i].email == data.userDetailParams[c].email){
									data.courses[i].gender = data.userDetailParams[c].gender;
									data.courses[i].timePeriodEnd = data.userDetailParams[c].timePeriodEnd;
									data.courses[i].works = data.userDetailParams[c].list;
						
								}
							}
						}
					}
					}
					
					this.courses = data.courses;
					this.total = data.total;
					this.ifSubmit = true;
					
					
					this.studentIdList = this.defaultStudentIdList;
					this.courseIdList = this.defaultCourseIdList;
					
				})
			},
			getDay(day){
			  var today = new Date();
			  var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
			  today.setTime(targetday_milliseconds); //注意，这行是关键代码
			  var tYear = today.getFullYear();
			  var tMonth = today.getMonth();
			  var tDate = today.getDate();
			  tMonth = this.doHandleMonth(tMonth + 1);
			  tDate = this.doHandleMonth(tDate);
			  return tYear + "-" + tMonth + "-" + tDate;
			},
			  doHandleMonth(month) {
			    var m = month;
			    if (month.toString().length == 1) {
			      m = "0" + month;
			    }
			    return m;
			  },
			  timeGroup(list){
			  	//日期分组
			  	let list2 = [];
			  	let str = list[0];
			  	let detail = [list[0]];
			  	for (let i = 1; i < list.length; i++) {
			  	  if (list[i].substring(0, 10) == str.substring(0, 10)){
			  		detail.push(list[i]);
			  	  }else{
			  		list2.push(detail);
			  		detail = [list[i]]; 
			  	  }
			  	  str = list[i];
			  	} 
			  	list2.push(detail);
			  	//日期计算
			  	let list3 = [];
			  	for (let i = 0; i < list2.length; i++) {
			  		let str = list2[i][0];
			  		let startTime = list2[i][0];
			  		for (let c = 1; c < list2[i].length; c++) {
			  		  if (str.substring(19, 24) == list2[i][c].substring(11, 16)) {
			  			startTime = startTime.substring(0,19)+list2[i][c].substring(19, 24);
			  		  }else{
			  			  list3.push(startTime);
			  			  startTime = list2[i][c];
			  		  }
			  		  str = list2[i][c];
			  		}
			  		list3.push(startTime);
			  	}
			  	return list3;
			  },
			  changeTeacher(detail){
			  	let list = [];
			  	for(let c=0;c<this.appointmentsDetail.teacherId.length;c++){
			  		let i=0;
			  		for(i=0;i<this.classTeacherList.length;i++){
			  			if(this.classTeacherList[i].id == this.appointmentsDetail.teacherId[c]){
			  				list.push(this.classTeacherList[i]);
			  				break;
			  			}
			  		}
			  		if(i == this.classTeacherList.length){
			  			for(let o=0;o<this.options2.length;o++){
			  				if(this.options2[o].value == this.appointmentsDetail.teacherId[c]){
			  					list.push({
			  						id:this.options2[o].value,
			  						name:this.options2[o].label,
			  						classModelHours:1
			  					});
			  					break;
			  				}
			  			}
			  		}
			  	}
			  	if(list.length == 0){
			  		for(let c=0;c<this.appointmentsDetail.teacherId.length;c++){
			  			for(let o=0;o<this.options2.length;o++){
			  				if(this.options2[o].value == this.appointmentsDetail.teacherId[c]){
			  					list.push({
			  						id:this.options2[o].value,
			  						name:this.options2[o].label,
			  						classModelHours:1
			  					});
			  					break;
			  				}
			  			}
			  		}
			  	}
			  	this.classTeacherList = list;
			  }
		},
		mounted() {
			this.pageSize = parseInt((window.innerHeight-200)/60);
			
			if((new Date().getTimezoneOffset() / -60) > 0){
				this.ifPek = false;
			}else{
				this.ifPek = true;
			}
			
			//查询课程分类
			this.ifSubmit = false;
			utils.requestPost("课程管理查询课程", "course/getCoursesTypes",{
			}).then((data) => {
				
				this.courseList = data.courseList;
				this.headmasterList = data.headmasterList;
				this.studentList = data.studentList;
				this.teacherList = data.teacherList;
				
				let name = utils.getAccountName();
				//查询班主任信息，默认去查询班主任下面的课程
				for(let i=0;i<this.headmasterList.length;i++){
					if(this.headmasterList[i].headmasterName == name){
						this.headmasterId = this.headmasterList[i].id;
						break;
					}
				}
				
				//查询课程
				this.getCourses();
			})
			
			//获取当前时间，设置为00:00:00
			let nowDate = new Date();
			nowDate.setMinutes(0);
			nowDate.setHours(0);
			nowDate.setSeconds(0);
			let time = [];
			for(let i=0;i<15;i++){
				if(i != 0)nowDate.setDate(nowDate.getDate()+1);
				let list = [{ id: 0, name: utils.getDetailTime(nowDate,4)}];
				for (let d = 0; d < 24; d++) {
					if(d != 0)nowDate.setHours(nowDate.getHours()+1);
					list.push({id: d + "s"+i,
					name: utils.getDetailTime(nowDate,2)+" ~ "+((nowDate.getHours()+1) < 10?"0":"")+(nowDate.getHours()+1)+":00",
					checked:false,disabled: false,});
				}
				nowDate.setHours(0);
				time.push(list);
			}
			this.time = time;
			
			//导师信息
			utils.requestGet("查询导师信息", "teacher/select",null).then((data) => {
				this.options2 = [];
				for (let i in data) {
					this.gridsearch2 = {
						value: "",
						label: ""
					};
					this.gridsearch2.value = String(data[i].id);
					this.gridsearch2.label += String(data[i].teacherName);
					this.options2 = this.options2.concat(this.gridsearch2);
				}
			});
			
		}
	};
</script>

<style scoped>
	
	.el-table >>> .el-table__expanded-cell[class*="cell"] {
	  padding:0px;
	}
</style>

<style >
	
	  .el-table .warning-row {
	    background: oldlace;
	  }
	
	  .el-table .tab1-row {
	    background: #f2f7ff;
	  }
	 
	 .el-table .tab2-row {
	   background: #f0f9ff;
	 } 
	 
	 .el-table .tab3-row {
	   background: #eaf4ff;
	 } 
	  
	 .bk-primary{
		 background-color: #409EFF;
	 }
	 .bk-success{
		background-color: #67C23A;
	 }
	 .bk-warning{
	 	background-color: #fff701;
	 }
	 .bk-danger{
	 	background-color: #F56C6C;
	 }
	  
	  
	
</style>
